import { MortgageRateTableDimensions } from '@bankrate/mortgage-types'
import { action, Action, thunk, Thunk } from 'easy-peasy'
import { populateFromQueryParams, updateQueryParams } from 'utils/queryParams'
import { stateToQueryParamsMap } from './dimensions'

export interface InitializationModel {
  hasInitialized: boolean

  setHasInitialized: Action<InitializationModel, boolean>

  initialize: Thunk<InitializationModel>

  hideLoanAmountTooltip: boolean

  setHideLoanAmountTooltip: Action<InitializationModel, boolean>
}

const initialization: InitializationModel = {
  hasInitialized: false,

  setHasInitialized: action((state, value) => {
    state.hasInitialized = value
  }),

  initialize: thunk(async (actions, payload, { getState, getStoreState, getStoreActions }): Promise<void> => {
    // protection against this thunk ever running besides once on initialization
    if (!getState().hasInitialized) {
      const increment = (getStoreActions() as any)['datadog'].increment
      const updateLocation = (getStoreActions() as any)['location'].update
      const dimensions = (getStoreState() as any)['dimensions'].dimensions

      // let query params take total precedence
      const combinedInitialDimensions = populateFromQueryParams<MortgageRateTableDimensions>(
        dimensions,
        stateToQueryParamsMap,
        globalThis.location.search
      )

      // set the url query params with combined initial dimensions
      updateQueryParams(combinedInitialDimensions, stateToQueryParamsMap)

      // set the store with the same combined initial dimensions
      await updateLocation(combinedInitialDimensions.zipCode)

      // render metric
      increment({ name: 'renders', value: 1 })

      actions.setHasInitialized(true)

      await (getStoreActions() as any)['offers'].getOffers(combinedInitialDimensions)
    }
  }),

  hideLoanAmountTooltip: false,

  setHideLoanAmountTooltip: action((state, value) => {
    state.hideLoanAmountTooltip = value
  }),
}

export default initialization
